import { Subject, Subscription } from 'rxjs';

declare type ToastPosition = 'top' | 'top-start' | 'top-end' | 'center' | 'center-start' | 'center-end' | 'bottom' | 'bottom-start' | 'bottom-end'
declare type ToastType =  'primary' | 'success' | 'error' | 'warning' | 'info'

declare type ToastOpenFn = (input: ToastOptions) => void;
declare type ToastCloseFn = () => void;

export interface ToastOptions {
    /**
     * Tipo do toast
     */
    type?: ToastType;
    /**
     * Mensagem do toast
     */
    message: string;
    /**
     * Posição do toast padrão 'bottom'
     */
    position?: ToastPosition;
    /**
     * Duração do toast padrão sem duração (infinito)
     */
    duration?: number;
    /**
     * Mostrar botão de fechar padrão false
     */
    showCloseButton?: boolean;
    /**
     * Texto do botão fechar padrão "fechar"
     */
    closeButtonText?: string;
}

const openSubject: Subject<ToastOptions> = new Subject();
const closeSubject: Subject<void> = new Subject();

export class ToastService {
    /**
     * Escuta as chamadas de abertura de toast
     * @param fn Função callback quando um toast é aberto
     */
    static registerOnToastOpen(fn: ToastOpenFn): Subscription {
        return openSubject.subscribe(fn);
    }

    /**
     * Escuta as chamadas de abertura de toast
     * @param fn Função callback quando um toast é aberto
     */
    static registerOnToastClose(fn: ToastCloseFn): Subscription {
        return closeSubject.subscribe(fn);
    }

    static open(mensagem: string): void;
    static open(options: ToastOptions): void;
    static open(token: (string | ToastOptions)) {
        let options: ToastOptions;
        if (typeof token == 'string')
            options = {
                message: token,
                duration: 3000
            }
        else
            options = token;

        openSubject.next(options);
    }

    static close() {
        closeSubject.next();
    }
}